import axios from "axios";
import AppConfig from "../../config/AppConfig";

export function WalletGetBalance(username) {
  return axios.get(AppConfig.WalletApi + "/getWallet", {
    params: { username },
  });
}
